/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetCampaignLaunchReadinessQueryResponse,
  GetCampaignLaunchReadinessPathParams,
  GetCampaignLaunchReadiness404,
} from '../../types/GetCampaignLaunchReadiness'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getCampaignLaunchReadiness } from '../../clients/getCampaignLaunchReadiness'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getCampaignLaunchReadinessQueryKey = ({
  campaign_id,
}: {
  campaign_id: GetCampaignLaunchReadinessPathParams['campaign_id']
}) =>
  [
    {
      url: '/api/v1/emailbison/campaigns/:campaign_id/launch-readiness/',
      params: { campaign_id: campaign_id },
    },
  ] as const

export type GetCampaignLaunchReadinessQueryKey = ReturnType<
  typeof getCampaignLaunchReadinessQueryKey
>

export function getCampaignLaunchReadinessQueryOptions(
  {
    campaign_id,
  }: { campaign_id: GetCampaignLaunchReadinessPathParams['campaign_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getCampaignLaunchReadinessQueryKey({ campaign_id })
  return queryOptions<
    GetCampaignLaunchReadinessQueryResponse,
    ResponseErrorConfig<GetCampaignLaunchReadiness404>,
    GetCampaignLaunchReadinessQueryResponse,
    typeof queryKey
  >({
    enabled: !!campaign_id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getCampaignLaunchReadiness(
        { campaign_id: campaign_id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @description Validate launch readiness using fresh EmailBison API state.
 * Endpoint:
 * - GET /api/emailbison/campaigns/<campaign_id>/launch-readiness/
 * @summary Get campaign launch readiness
 * {@link /api/v1/emailbison/campaigns/:campaign_id/launch-readiness/}
 */
export function useGetCampaignLaunchReadiness<
  TData = GetCampaignLaunchReadinessQueryResponse,
  TQueryData = GetCampaignLaunchReadinessQueryResponse,
  TQueryKey extends QueryKey = GetCampaignLaunchReadinessQueryKey,
>(
  {
    campaign_id,
  }: { campaign_id: GetCampaignLaunchReadinessPathParams['campaign_id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetCampaignLaunchReadinessQueryResponse,
        ResponseErrorConfig<GetCampaignLaunchReadiness404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    getCampaignLaunchReadinessQueryKey({ campaign_id })

  const query = useQuery(
    {
      ...getCampaignLaunchReadinessQueryOptions({ campaign_id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetCampaignLaunchReadiness404>
  > & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}
